import { render } from "./Categoria.vue?vue&type=template&id=a269eacc&scoped=true"
import script from "./Categoria.vue?vue&type=script&lang=js"
export * from "./Categoria.vue?vue&type=script&lang=js"

import "./Categoria.vue?vue&type=style&index=0&id=a269eacc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a269eacc"]])

export default __exports__